import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\n  <path d=\"M6.66667 12V0H10V12H6.66667ZM0 12V0H3.33333V12H0Z\" fill=\"#253780\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol